<template>
    <div :class="wrapperClass">
        <p class="text-center mb-4" style="font-size: 1.3em;" v-if="message">{{ message }}</p>
        <div class="d-flex d-flex justify-content-center">
            <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            message: String,
            wrapperClass: {
                type: String, 
                default: 'mt-5 mb-5'
            }
        }       
    }
</script>